"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#007AFF",
    d: "M1.039 9.978c-.218-2.063.359-4.79 4.938-6.896C5.633 2.378 5.301 1.684 4.98 1l7.201 1.027-3.746 5.961-.744-1.632c-2.364 0-4.582 1.207-6.652 3.622z"
  }));
}

var MemoSvgForward = /*#__PURE__*/React.memo(SvgForward);
var _default = MemoSvgForward;
exports["default"] = _default;